export const addOrRemove = <T>(array: T[], item: T, predicate?: (item: T) => any) => {
  const index = predicate ? array.findIndex((i) => predicate(i)) : array.indexOf(item);

  if (index !== -1) {
    return [...array.slice(0, index), ...array.slice(index + 1)];
  } else {
    return [...array, item];
  }
};
